import { gql, useQuery } from "@apollo/client"
import { get } from "lodash"
import { useMemo } from "react"
import { readSettings } from "../../../reducers/globalsettings"

export const GET_GLOBALSETTINGS = gql`
  query GlobalSettings {
    globalSettings {
      items {
        activitiesColumns
        articleApproval
        automatedExportFilePathProgresses
        automatedImportDeputy {
          id
        }
        automatedImportDeputyId
        activitiesColumnsExternal
        automatedImportResponsible {
          id
        }
        automatedImportResponsibleId
        automatedImportFilePathArticles
        automatedImportFilePathOrderPositions
        automaticProductionOrderLock
        colorType
        checkPlausibility
        closeGapsDisabled
        checkActivitiesPlausibility
        defaultTermination
        donePreviousOperationsByDefault
        freeMoveTimeline
        freeMoveProductionTimeline
        importDefaultArticle {
          id
        }
        importDefaultArticleId
        importIgnoreChangedDeliveryDate
        monthsInPast
        monthsInFuture
        moveResourcesAcrossGroups
        oeeEfficiencyCalc
        operationsColumns
        oeeAvailabilityCalc
        orderPositionsColumns
        optimizeWorkloadDisabled
        operationsColumnsExternal
        planeusApiToken
        processItemLabel
        productionOrderItemLabel
        projectsColumns
        pendingByDefault
        productionOrdersColumns
        resourcePlanningItemLabel
        terminalAutomatedFeedbackParallelOperations
        weekendDays
        workbenchAmountOptional
        workbenchAmountValidation
        workbenchAutomatedLogOut
        workbenchDurationOptional
        workbenchAutomatedLogOutTime
        workloadRoundMultipleReservations
        workbenchTicketDescriptionActivities
        workbenchTicketDescriptionOperations
        anonymousProgressFeedback
        printBarcodeFormat
        printBarcodeWithEnter
        punctualityTolerance
        hasTwoFactorAuthentication
      }
    }
  }
`

const useFetchData = () => {
  const { data: globalSettingsData, refetch } = useQuery(GET_GLOBALSETTINGS)

  const parsedData = useMemo(() => {
    const globalSettings = get(globalSettingsData, "globalSettings.items[0]", null)
    return globalSettings ? readSettings(globalSettings) : null
  }, [globalSettingsData])

  return {
    parsedData,
    refetch,
  }
}

export default useFetchData
